function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useMemo } from 'react';
import cn from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { Popover as MuiPopover } from '@material-ui/core';
import colors from "../../foundations/colors.module.scss";
import shadows from "../../foundations/shadows.module.scss";
const useStyles = makeStyles({
  paper: {
    background: colors.dark50,
    boxShadow: shadows.sh60,
    borderRadius: 8
  }
});
/** A customized popover based on Material-UI's Popover component. */

export function Popover(props) {
  var _props$anchorOrigin, _additionalProps$anch;

  const {
    classes
  } = props;
  const overrides = useStyles();
  const actualClasses = useMemo(() => {
    return _objectSpread({
      paper: cn(overrides.paper, classes && classes.paper)
    }, classes || {});
  }, [classes, overrides]);
  const additionalProps = {};

  if (!(props !== null && props !== void 0 && (_props$anchorOrigin = props.anchorOrigin) !== null && _props$anchorOrigin !== void 0 && _props$anchorOrigin.horizontal)) {
    additionalProps.anchorOrigin = {
      vertical: 'bottom',
      horizontal: 'left'
    };
  }

  if ((additionalProps === null || additionalProps === void 0 ? void 0 : (_additionalProps$anch = additionalProps.anchorOrigin) === null || _additionalProps$anch === void 0 ? void 0 : _additionalProps$anch.horizontal) === 'left') {
    additionalProps.transformOrigin = {
      vertical: -8,
      horizontal: 'left'
    };
  }

  return /*#__PURE__*/React.createElement(MuiPopover, _extends({}, props, {
    classes: actualClasses
  }, additionalProps));
}